(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name webAgro1App.controller:RelatorioVisitaCustomizadoEditImageCtrl
   * @description
   * # RelatorioVisitaCustomizadoEditImageCtrl
   * Controller of the webAgro1App
   */
  angular.module('webAgro1App')
    .controller('RelatorioVisitaCustomizadoEditImageCtrl', RelatorioVisitaCustomizadoEditImageCtrl);

  RelatorioVisitaCustomizadoEditImageCtrl.$inject = [
    '$uibModalInstance',
    'image',
    '$timeout'
  ];

  function RelatorioVisitaCustomizadoEditImageCtrl($uibModalInstance, image, $timeout) {
    var vm = this;
    var initialized = false;

    //////////////////////////////////////////
    // Controller data
    vm.image = image;
    vm.loading = true;
    vm.tmpImage = new Image();
    vm.canvas = null;

    //////////////////////////////////////////
    // Bindable methods
    vm.close = Close;
    vm.save = Save;
    vm.reset = Reset;
    vm.showEditor = ShowEditor;

    //////////////////////////////////////////
    // Function declarations

    function Close() {
      $uibModalInstance.dismiss();
    }

    function Save() {
      $uibModalInstance.close(vm.canvas.toDataURL());
    }

    function Reset() {
      $uibModalInstance.dismiss('reset');
    }

    function ShowEditor() {
      vm.loading = false;
      vm.canvas = document.querySelector('#edit-image-canvas');
      if (!initialized) {
        initialized = true;
        $timeout(function() {
          var ctx = vm.canvas.getContext('2d');

          new Sketchpad({
            element: '#edit-image-canvas',
            color: '#f00',
            penSize: 5,
            width: vm.tmpImage.width,
            height: vm.tmpImage.height
          });

          ctx.drawImage(vm.tmpImage, 0, 0);
        }, 0);
      }
    }

    //////////////////////////////////////////
    // Controller logic

    vm.tmpImage.addEventListener('load', vm.showEditor);
    vm.tmpImage.crossOrigin = 'Anonymous';
    vm.tmpImage.src = vm.image.editedURL || vm.image.report;
  }

}());
